/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Beginner_2_HeadingInputs */

const en_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arms folding is a good sign`)
};

const es_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que los brazos se plieguen es una buena señal`)
};

const de_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Verschränken der Arme ist ein gutes Zeichen`)
};

const zh_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手臂折叠是好迹象`)
};

const ar_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انثناء الذراعين علامة جيدة`)
};

const fr_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des bras qui se plient, c’est bon signe`)
};

const vi_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cánh tay gập là dấu hiệu tốt`)
};

const sw_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikono kukunjika ni ishara nzuri`)
};

const th_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แขนที่พับคือสัญญาณที่ดี`)
};

const bs_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Savijanje ruku je dobar znak`)
};

const ja_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`腕がたたまれるのは良いサイン`)
};

const ko_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팔이 접히는 것은 좋은 신호입니다`)
};

const pt_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Braços que se dobram são um bom sinal`)
};

const it_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le braccia che si piegano sono un buon segno`)
};

const sv_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Att armarna viker sig är ett gott tecken`)
};

const nl_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vouwende armen zijn een goed teken`)
};

const da_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foldede arme er et godt tegn`)
};

const nb_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At armene folder seg, er et godt tegn`)
};

const fi_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsivarsien koukistuminen on hyvä merkki`)
};

const pl_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zginanie rąk to dobry znak`)
};

const ru_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сгибание рук — хороший знак`)
};

const tr_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolların katlanması iyiye işarettir`)
};

const hi_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बाँहों का मुड़ना अच्छा संकेत है`)
};

const id_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengan yang menekuk adalah pertanda baik`)
};

const ms_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengan yang melipat ialah petanda baik`)
};

const cs_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohýbání paží je dobré znamení`)
};

const el_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το δίπλωμα των χεριών είναι καλό σημάδι`)
};

const he_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קיפול הזרועות הוא סימן טוב`)
};

const af_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arms wat vou is 'n goeie teken`)
};

const hu_method_content_step_04_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A karok behajlása jó jel`)
};

/**
* | output |
* | --- |
* | "Arms folding is a good sign" |
*
* @param {Method_Content_Step_04_Detail_Beginner_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_beginner_2_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Beginner_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Beginner_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_beginner_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_beginner_2_heading(inputs)
	return en_method_content_step_04_detail_beginner_2_heading(inputs)
});